// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue2-dropzone/dist/vue2Dropzone.css
// module id = 955
// module chunks = 1